import AuthForm, { LoginFormMode } from 'components/auth-form';
import { IntroWrapper } from 'components/auth-form/auth-form.styles';
import { FeatureList, FeatureListItem } from 'components/feature-list';
import { H4 } from 'components/headings';
import Layout from 'components/layout';
import SEO from 'components/seo';
import ContentSection from 'components/ui/content-section';
import { GetStaticProps, NextPage } from 'next';
import { useRouter } from 'next/router';
import { useEffectOnce } from 'react-use';
import AnalyticsService, { ScreenNames } from 'services/analytics';
import { backgroundImages } from 'utils/config';

const PAGE_TITLE = 'Create account';
const PAGE_DESCRIPTION =
  'Save and keep your plan up-to-date throughout the year and get reminders to help you prepare your property for bushfire season.';

const SignUp: NextPage = () => {
  const router = useRouter();
  const { widthEditControls } = router.query;
  const showEditControls = widthEditControls === 'true';

  useEffectOnce(() => {
    AnalyticsService.trackScreen(ScreenNames.register);
  });

  return (
    <Layout
      mainBackground={backgroundImages.hero}
      showEditControls={showEditControls}
    >
      <SEO title={PAGE_TITLE} description={PAGE_DESCRIPTION} />
      <ContentSection textAlign='center'>
        <IntroWrapper>
          <H4 as='h1'>Create an account and save your plan</H4>
          <FeatureList>
            <FeatureListItem>
              Download and access your plan any time on your device
            </FeatureListItem>
            <FeatureListItem>
              Regularly review and update your plan
            </FeatureListItem>
            <FeatureListItem>
              Share your completed plan with family and friends
            </FeatureListItem>
          </FeatureList>
        </IntroWrapper>
        <AuthForm mode={LoginFormMode.signUp} />
      </ContentSection>
    </Layout>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
  };
};

export default SignUp;
